import URI from 'urijs';

/**
 * A convenience function for catching incoming UTM parameter in the URL
 * by using urijs library
 * returning a string;
 */

export const getUtmParams = (utmParams = null, stringify = false) => {
  let fullParams;
  if (utmParams !== null || !window.location.search) {
    fullParams = utmParams || {};
  } else {
    fullParams = URI(window.location.search).query(true);
  }
  const utmQueryParams = Object.entries(fullParams)
    .filter(([name, value]) => name.match(/^utm_/) && value !== undefined)
    .map(([name, value]) => `${name}=${value}`)
    .join('&');

  return stringify
    ? URI().query(utmQueryParams).query() // Chars after the ?
    : utmQueryParams;
};

/**
 * Convenience function for adding query string params
 */
export const addQueryStringParams = (
  baseUri: string,
  newParams?: { [key: string]: any },
): string => {
  const baseParams = URI(baseUri).query(true);
  return URI(baseUri)
    .query({
      ...baseParams,
      ...newParams,
    })
    .href();
};
